import { motion } from 'framer-motion';
import React from 'react';

interface DropdownIndicatorProps {
  isFlipped?: boolean;
  width?: number;
  height?: number;
}

export const DropdownIndicator = ({
  isFlipped,
  width,
  height,
}: DropdownIndicatorProps) => {
  return (
    <motion.svg
      width={width ?? 12}
      height={height ?? 8}
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // Set the origin to stop framer motion overriding
      // https://github.com/framer/motion/issues/255
      style={{ originX: 0.5, originY: 0.5 }}
      transition={{
        type: 'tween',
        duration: 0.1,
      }}
      animate={{
        rotate: isFlipped ? 180 : 0,
      }}
    >
      <path
        d="M1 1L6 7L11 1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </motion.svg>
  );
};

export default DropdownIndicator;
